import server from '../utils/server';

// Actions

const FETCH_CHANNELS_SUCCESS = 'channels/FETCH_CHANNELS_SUCCESS';

// Reducer

const initialState = [];

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_CHANNELS_SUCCESS: {
      return action.channels || state;
    }
    default: {
      return state;
    }
  }
}

// Action Creators

const fetchChannelsSuccess = channels => ({
  type: FETCH_CHANNELS_SUCCESS,
  channels,
});

// Thunks

export const fetchChannels = (integrated = true) => async dispatch => {
  const { channels } = await server.get(
    `/api/v1/channels?integrated=${integrated}`
  );
  dispatch(fetchChannelsSuccess(channels));
};
